import React, { useEffect, useRef } from 'react';
import './AnimatedBackground.css';

const AnimatedBackground = ({ particleCount = 25, staticCount = 8, customImages = [] }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    const createParticles = () => {
      const container = containerRef.current;
      if (!container) return;
      
      // Limpiar partículas existentes
      container.innerHTML = '';
      
      const colors = ['#cc9933', '#003300', '#990000', '#5D0C17', '#000000'];
      
      // Reducir círculos al 60%
      const circleCount = Math.floor(particleCount * 0.6);
      const staticCircleCount = Math.floor(staticCount * 0.6);
      
      // Crear partículas animadas (círculos)
      for (let i = 0; i < circleCount; i++) {
        const particle = document.createElement('div');
        particle.classList.add('particle');
        
        // Propiedades aleatorias
        const size = Math.random() * 60 + 15;
        const posX = Math.random() * 100;
        const posY = Math.random() * 120; // Permitir partículas fuera de la pantalla
        const color = colors[Math.floor(Math.random() * colors.length)];
        const delay = Math.random() * 20;
        const duration = 20 + Math.random() * 25;
        
        particle.style.width = `${size}px`;
        particle.style.height = `${size}px`;
        particle.style.left = `${posX}%`;
        particle.style.top = `${posY}%`;
        particle.style.background = color;
        particle.style.animationDelay = `${delay}s`;
        particle.style.animationDuration = `${duration}s`;
        
        container.appendChild(particle);
      }

      // Agregar partículas estáticas (círculos) para profundidad
      for (let i = 0; i < staticCircleCount; i++) {
        const staticParticle = document.createElement('div');
        staticParticle.classList.add('particle', 'static-particle');
        
        const size = Math.random() * 30 + 10;
        const posX = Math.random() * 100;
        const posY = Math.random() * 100;
        const color = colors[Math.floor(Math.random() * colors.length)];
        
        staticParticle.style.width = `${size}px`;
        staticParticle.style.height = `${size}px`;
        staticParticle.style.left = `${posX}%`;
        staticParticle.style.top = `${posY}%`;
        staticParticle.style.background = color;
        staticParticle.style.opacity = '0.2';
        staticParticle.style.animation = 'none';
        
        container.appendChild(staticParticle);
      }

      // Agregar imágenes personalizadas flotantes (sin rotación, suben rectas)
      customImages.forEach((imageSrc, index) => {
        const imageParticle = document.createElement('div');
        imageParticle.classList.add('image-particle');
        
        const img = document.createElement('img');
        img.src = imageSrc;
        img.alt = `Floating decoration ${index + 1}`;
        
        // Propiedades aleatorias para las imágenes
        const size = Math.random() * 60 + 30; // Tamaño entre 30px y 90px
        const posX = Math.random() * 100;
        const posY = Math.random() * 120;
        const delay = Math.random() * 20;
        const duration = 20 + Math.random() * 25; // Misma velocidad que los círculos
        
        imageParticle.style.width = `${size}px`;
        imageParticle.style.height = `${size}px`;
        imageParticle.style.left = `${posX}%`;
        imageParticle.style.top = `${posY}%`;
        imageParticle.style.animationDelay = `${delay}s`;
        imageParticle.style.animationDuration = `${duration}s`;
        
        // Animación sin rotación
        imageParticle.style.animation = `float-image-straight ${duration}s infinite linear`;
        
        imageParticle.appendChild(img);
        container.appendChild(imageParticle);
      });
    };

    // Crear partículas después de un pequeño delay para asegurar que el DOM esté listo
    const timer = setTimeout(createParticles, 100);
    
    return () => {
      clearTimeout(timer);
    };
  }, [particleCount, staticCount, customImages]);

  return <div ref={containerRef} className="animated-background"></div>;
};

export default AnimatedBackground;
